import { render, staticRenderFns } from "./add_stadium_ground.vue?vue&type=template&id=1ca87a39&"
import script from "./add_stadium_ground.vue?vue&type=script&lang=ts&"
export * from "./add_stadium_ground.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports